// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import type {PaymentProvider, Store} from '../../../../entities';
import {useRef} from 'react';
// import {commaFormat} from '../../../../utils/number';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as CheckoutActions} from '../../duck';
import type {PayUInitialization} from '../../duck';
import type {SubscribeRequest} from '../../api';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';
import {useEffect} from 'react';
import environment from '../../../../environment';
import {getBasicDomain} from '../../../../utils/component';

export default connect(
  (state: RootState) => ({
    payUInitialization: state.checkout.payUInitialization,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...CheckoutActions,
      },
      dispatch
    )
)(PayUPaymentButton);

type Props = {
  store: Store,
  selectedCard: string,
  paymentProvider: PaymentProvider,
  paymentSettings: {
    currency: string,
    description: string,
    planId: string,
    country: string,
    amount: string,
  },
  watch: string => string,
  disabled?: boolean,
  onSubmit: (tokenId: string) => void,
  payUInitialize: ({subscribeRequest: SubscribeRequest}) => void,
  payUInitialization?: PayUInitialization,
  paymentStepAnalyticsEvent: (callback?: () => void) => void,
};

const useStyles = makeStyles(theme => ({
  confirmButton: {
    zIndex: 1,
    height: 48,
    margin: theme.spacing(1, 0),
    fontWeight: 600,
    fontSize: '1.125rem',
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      left: 0,
      bottom: 64,
      margin: theme.spacing(2),
      width: `calc(100% - ${theme.spacing(4)})`,
    },
  },
}));

function PayUPaymentButton(props: Props) {
  const {
    store,
    paymentProvider,
    paymentSettings,
    watch,
    disabled,
    onSubmit,
    selectedCard,
    payUInitialize,
    payUInitialization,
    paymentStepAnalyticsEvent,
  } = props;

  const classes = useStyles();

  const formRef = useRef(null);

  const handleClick = e => {
    paymentStepAnalyticsEvent();
    e.persist();
    if (selectedCard && selectedCard !== 'NEW') {
      onSubmit('');
    } else {
      const subscribeRequest: SubscribeRequest = {
        automaticCharge: false,
        storeTierPlanId: paymentSettings.planId,
        coupon: watch('coupon') || undefined,
        currency: paymentSettings.currency,
        paymentData: {
          payWithCard: false,
          billingAddress: {
            firstName: watch('firstName'),
            lastName: watch('lastName'),
            idNumber: watch('idNumber'),
            // email: data.email,
            // razonSocial:data.razonSocial,
            // ruc:data.ruc,
            address1: watch('address'),
            country: paymentSettings.country,
            admin1: watch('admin1') || undefined,
            admin2: watch('admin2') || undefined,
            admin3: watch('admin3') || undefined,
          },
          paymentProviderId: paymentProvider ? paymentProvider.id : undefined,
          processorParameters: {
            payu: {},
            name: 'payu',
          },
          savePaymentInformation: false,
        },
      };
      payUInitialize({subscribeRequest});
    }
  };

  useEffect(() => {
    if (
      payUInitialization &&
      payUInitialization.signature &&
      payUInitialization.subscriptionId &&
      formRef.current
    )
      formRef.current.submit();
  }, [payUInitialization]);

  const payUUrl =
    environment.environment === 'production'
      ? 'https://checkout.payulatam.com/ppp-web-gateway-payu/'
      : 'https://sandbox.checkout.payulatam.com/ppp-web-gateway-payu/';

  return (
    <>
      <form ref={formRef} method="post" action={payUUrl}>
        <input
          name="merchantId"
          type="hidden"
          value={paymentProvider.serverParameters.merchantId}
        />
        <input
          name="accountId"
          type="hidden"
          value={paymentProvider.serverParameters.accountId}
        />
        <input
          name="description"
          type="hidden"
          value={paymentSettings.description}
        />
        <input
          name="referenceCode"
          type="hidden"
          value={payUInitialization && payUInitialization.subscriptionId}
        />
        <input name="amount" type="hidden" value={paymentSettings.amount} />
        {/* <input
            name="tax"
            type="hidden"
            value={commaFormat(parseFloat(paymentSettings.amount) * 0.18)}
            // value="0"
          />
          <input
            name="taxReturnBase"
            type="hidden"
            value={commaFormat(parseFloat(paymentSettings.amount) * 0.82)}
            // value="0"
          /> */}
        <input name="currency" type="hidden" value={paymentSettings.currency} />
        <input
          name="signature"
          type="hidden"
          value={payUInitialization && payUInitialization.signature}
        />
        {environment.environment !== 'production' && (
          <input name="test" type="hidden" value="true" />
        )}
        <input name="algorithmSignature" type="hidden" value="SHA256" />
        <input
          name="buyerFullName"
          type="hidden"
          value={`${watch('firstName')} ${watch('lastName')}`}
        />
        <input name="buyerEmail" type="hidden" value={watch('email')} />
        <input
          name="responseUrl"
          type="hidden"
          value={`https://${getBasicDomain(store.domains)}/admin/home`}
        />
        <input
          name="confirmationUrl"
          type="hidden"
          value={`https://${getBasicDomain(
            store.domains
          )}/api/checkout/admin/subscription/complete/payu-web`}
        />
        {/* <input name="Submit" type="submit" value="Enviar" /> */}
      </form>

      <CustomButton
        variant="contained"
        className={classes.confirmButton}
        onClick={handleClick}
        disabled={disabled}
      >
        Proceder a pagar
      </CustomButton>
    </>
  );
}

PayUPaymentButton.propTypes = {
  store: PropTypes.object,
  selectedCard: PropTypes.string.isRequired,
  paymentProvider: PropTypes.object,
  paymentSettings: PropTypes.object,
  watch: PropTypes.func,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  payUInitialize: PropTypes.func,
  payUInitialization: PropTypes.object,
  paymentStepAnalyticsEvent: PropTypes.func,
};
